// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"69b60f6f","128":"c12a19d8","156":"12128bee","213":"08462194","282":"4f55baa5","434":"d04860fe","453":"4d6ed93c","484":"0a188285","485":"4840f40b","512":"873b84d5","557":"61731542","594":"ac0fee5e","709":"cf8923f1","723":"f9fcbcde","837":"af43fbf1","947":"3ce52988"}[chunkId] + ".chunk.js";
};